import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { legalPagesApi } from "./api";
import type { LegalPage, LegalPageInput } from "./types";

export const legalPageKeys = {
  all: ["legal-pages"] as const,
  publicList: ["legal-pages", "public"] as const,
  publicDetail: (slug: string) => ["legal-pages", "public", slug] as const,
};

export function usePublicLegalPages() {
  return useQuery({ queryKey: legalPageKeys.publicList, queryFn: legalPagesApi.publicList });
}

export function usePublicLegalPage(slug: string) {
  return useQuery({ queryKey: legalPageKeys.publicDetail(slug), queryFn: () => legalPagesApi.publicBySlug(slug), retry: false });
}

export function useLegalPages() {
  return useQuery({ queryKey: legalPageKeys.all, queryFn: legalPagesApi.list });
}

export function useUpdateLegalPage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ page, input }: { page: LegalPage; input: LegalPageInput }) => legalPagesApi.update(page.id, input),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: legalPageKeys.all }),
  });
}
